module.exports = __webpack_public_path__ + "images/emoji/womens.2ca4d61b175cd949a0e8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/womens.png
// module id = zX13
// module chunks = 13